import {useHistory, useParams} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import style from "./Resiger.scss";
import globalStyle from '@/styles/Global.scss'
import MButton from "@/components/atom/MButton";
import React, {useEffect, useState} from "react";
import {entryConfirm} from "@/api";

const CodeConfirm = (props) => {
  const { code } = useParams()
  const [showTimeOver, setShowTimeOver] = useState(false)
  const [showConfirmed, setShowConfirmed] = useState(false)
  const history = useHistory()

  useEffect(() => {
    (async () => {
      try {
        await entryConfirm({code})
        setShowConfirmed(true)
      } catch (_) {
        setShowTimeOver(true)
      }
    })()
  }, [code])

  const goBack = () => {
    history.push('/')
  }

  const goLogin = () => {
    history.push('/login')
  }

  return (
    <>
      <RegisterLayout>
        {
          showTimeOver &&
          <div className={style.container}>
            <div className={globalStyle.attribute}>
              <h3>メールの有効期限が切れました</h3>
            </div>
            <div className={globalStyle.attribute}>
              登録受け付けメールの有効期限が切れました。<br/>
              再度登録操作を行ってください。<br/>
            </div>
            <div className={globalStyle.attribute}>
              <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
            </div>
          </div>
        }
        {
          showConfirmed &&
          <div className={style.container}>
            <div className={globalStyle.attribute}>
              <h3>登録が完了しました</h3>
            </div>
            <div className={globalStyle.attribute}>
              名刺Rへの登録が完了しました。<br/>
              ログイン画面から、ログインをしてください。
            </div>
            <div className={globalStyle.attribute}>
              <MButton width={180} value={'ログイン画面へ'} onClick={goLogin}></MButton>
            </div>
          </div>
        }
      </RegisterLayout>
    </>
  )
}

export default CodeConfirm;
